import { router } from '@/router/index'

export const noticeTagMap = {
  '': undefined,
  /** 新闻中心-总会快递 */
  1: '/news/news',
  /** 新闻中心-校友信息 */
  2: '/news/schoolNews',
  /** 新闻中心-地区活动 */
  3: '/news/areaActivity',
  /** 新闻中心-院系活动 */
  4: '/news/collegesActivity',
  /** 新闻中心-行业兴趣 */
  5: '/news/businessNews',

  /** 校友联络-地区联络 */
  6: '/alumniContact/index/1',
  /** 校友联络-年级联络 */
  7: '/alumniContact/index/2',
  /** 校友联络-院系校友工作 */
  8: '/alumniContact/index/3',
  /** 校友联络-专业委员会 */
  9: '/alumniContact/index/4',
  /** 校友联络-兴趣群体 */
  10: '/alumniContact/index/5',

  /** 回馈母校-捐赠项目-励学金 */
  11: '/givingBack/project',
  /** 回馈母校-捐赠项目-年级校友基金 */
  12: '/givingBack/project',
  /** 回馈母校-捐赠项目-院系发展基金 */
  13: '/givingBack/project',
  /** 回馈母校-捐赠新闻 */
  14: '/givingBack/news',
  /** 回馈母校-捐赠纪事 */
  15: '/givingBack/record',
  /** 回馈母校-捐赠方法 */
  16: '/givingBack/method',
  /** 回馈母校-义工计划 */
  17: '/givingBack/plan',

  /** 媒体平台-联络校友通讯-在线阅读 */
  // 18: '/mediaPlatform/addressBook',
  /** 媒体平台-联络校友通讯-期刊简介 */
  // 19: '/mediaPlatform/addressBook',
  /** 媒体平台-学子风采-在线阅读 */
  20: '/mediaPlatform/addressBookXzfc',
  /** 媒体平台-学子风采-期刊简介 */
  21: '/mediaPlatform/addressBookXzfc',
  /** 媒体平台-社团风采-在线阅读 */
  22: '/mediaPlatform/addressBookClub',
  /** 媒体平台-社团风采-期刊简介 */
  23: '/mediaPlatform/addressBookClub',
  /** 媒体平台-我要订阅 */
  24: '/mediaPlatform/subscribe',
  /** 媒体平台-新媒体平台 */
  25: '/mediaPlatform/platform',

  /** 而立华联-华联人物 */
  26: '/history/person',
  /** 而立华联-华联故事 */
  27: '/history/story',
  /** 而立华联-校友文苑 */
  28: '/history/article',
  /** 而立华联-校友论坛 */
  29: '/history/pulpit',
  /** 而立华联-校友视界 */
  30: '/history/achievement',

  /** 校友服务-咨询服务 */
  31: '/alumniService/consultService',
  /** 校友服务-信息化服务 */
  32: '/alumniService/competition',
  /** 校友服务-实用信息 */
  33: '/alumniService/lifeStudy',
  /** 校友服务-双创大赛 */
  34: '/alumniService/infoService',
  /** 校友服务-继续教育 */
  35: '/alumniService/infoPractical',

  /** 招聘拓岗-校友企业招聘 */
  36: '/recruitment/companyRecruitment',
  /** 招聘拓岗-校园宣讲会 */
  37: '/recruitment/recruitmentTalk',
  /** 招聘拓岗-校园供需见面会 */
  38: '/recruitment/faceToFace',
  /** 招聘拓岗-校园专场招聘会 */
  39: '/recruitment/careerFair',
  /** 招聘拓岗-访企拓岗 */
  40: '/recruitment/companyInfo',

  /** 创业校友-国内创业校友 */
  41: '/setUpAlumnus/inChina',
  /** 创业校友-国外创业校友 */
  42: '/setUpAlumnus/outOfChina',
  /** 创业校友-品牌产品 */
  43: '/setUpAlumnus/products',
  /** 创业校友-校友商城 */
  44: '/setUpAlumnus/shopMall',

  /** 校友风采-国内优秀校友 */
  45: '/alumniProfile/domestic',
  /** 校友风采-国外优秀校友 */
  46: '/alumniProfile/overseas',
  /** 校友风采-突出贡献校友 */
  47: '/alumniProfile/outstandingContribution',
  /** 校友风采-媒体报道 */
  48: '/alumniProfile/mediaReports',

  /** 校友总会-总会简介 */
  49: '/alumniAssociation/introduct',
  /** 校友总会-会长致辞 */
  50: '/alumniAssociation/speak',
  /** 校友总会-总会章程 */
  51: '/alumniAssociation/rules',
  /** 校友总会-理事会名单 */
  52: '/alumniAssociation/nameList',
  /** 校友总会-联系我们 */
  53: '/alumniAssociation/laws',
  /** 校友总会-制度法规 */
  54: '/alumniAssociation/aboutUs',

  /** 照片 */
  55: '/alumniProfile/photo',
  /** 视频 */
  56: '/alumniProfile/video',

  /** 通知公告 */
  57: '/notice/announcement',
  /** 活动预告 */
  58: '/preview/events',
} as const

export const noticeTagNameMap = {
  '': undefined,
  /** 新闻中心-总会快递 */
  1: '总会快递',
  /** 新闻中心-校友信息 */
  2: '校友信息',
  /** 新闻中心-地区活动 */
  3: '地区活动',
  /** 新闻中心-院系活动 */
  4: '院系活动',
  /** 新闻中心-行业兴趣 */
  5: '行业兴趣',

  /** 校友联络-地区联络 */
  6: '地区联络',
  /** 校友联络-年级联络 */
  7: '年级联络',
  /** 校友联络-院系校友工作 */
  8: '院系校友工作',
  /** 校友联络-专业委员会 */
  9: '专业委员会',
  /** 校友联络-兴趣群体 */
  10: '兴趣群体',

  /** 回馈母校-捐赠项目-励学金 */
  11: '励学金',
  /** 回馈母校-捐赠项目-年级校友基金 */
  12: '年级校友基金',
  /** 回馈母校-捐赠项目-院系发展基金 */
  13: '院系发展基金',
  /** 回馈母校-捐赠新闻 */
  14: '捐赠新闻',
  /** 回馈母校-捐赠纪事 */
  15: '捐赠纪事',
  /** 回馈母校-捐赠方法 */
  16: '捐赠方法',
  /** 回馈母校-义工计划 */
  17: '义工计划',

  /** 媒体平台-联络校友通讯-在线阅读 */
  18: '联络校友通讯',
  /** 媒体平台-联络校友通讯-期刊简介 */
  19: '联络校友通讯',
  /** 媒体平台-学子风采-在线阅读 */
  20: '学子风采',
  /** 媒体平台-学子风采-期刊简介 */
  21: '学子风采',
  /** 媒体平台-社团风采-在线阅读 */
  22: '社团风采',
  /** 媒体平台-社团风采-期刊简介 */
  23: '社团风采',
  /** 媒体平台-我要订阅 */
  24: '我要订阅',
  /** 媒体平台-新媒体平台 */
  25: '新媒体平台',

  /** 而立华联-华联人物 */
  26: '华联人物',
  /** 而立华联-华联故事 */
  27: '华联故事',
  /** 而立华联-校友文苑 */
  28: '校友文苑',
  /** 而立华联-校友论坛 */
  29: '校友论坛',
  /** 而立华联-校友视界 */
  30: '校友视界',

  /** 校友服务-咨询服务 */
  31: '咨询服务',
  /** 校友服务-信息化服务 */
  32: '信息化服务',
  /** 校友服务-实用信息 */
  33: '实用信息',
  /** 校友服务-双创大赛 */
  34: '双创大赛',
  /** 校友服务-继续教育 */
  35: '继续教育',

  /** 招聘拓岗-校友企业招聘 */
  36: '校友企业招聘',
  /** 招聘拓岗-校园宣讲会 */
  37: '校园宣讲会',
  /** 招聘拓岗-校园供需见面会 */
  38: '校园供需见面会',
  /** 招聘拓岗-校园专场招聘会 */
  39: '校园专场招聘会',
  /** 招聘拓岗-访企拓岗 */
  40: '访企拓岗',

  /** 创业校友-国内创业校友 */
  41: '国内创业校友',
  /** 创业校友-国外创业校友 */
  42: '国外创业校友',
  /** 创业校友-品牌产品 */
  43: '品牌产品',
  /** 创业校友-校友商城 */
  44: '校友商城',

  /** 校友风采-国内优秀校友 */
  45: '国内优秀校友',
  /** 校友风采-国外优秀校友 */
  46: '国外优秀校友',
  /** 校友风采-突出贡献校友 */
  47: '突出贡献校友',
  /** 校友风采-媒体报道 */
  48: '媒体报道',

  /** 校友总会-总会简介 */
  49: '总会简介',
  /** 校友总会-会长致辞 */
  50: '会长致辞',
  /** 校友总会-总会章程 */
  51: '总会章程',
  /** 校友总会-理事会名单 */
  52: '理事会名单',
  /** 校友总会-联系我们 */
  53: '联系我们',
  /** 校友总会-制度法规 */
  54: '制度法规',

  /** 照片 */
  55: '照片',
  /** 视频 */
  56: '视频',

  /** 通知公告 */
  57: '通知公告',
  /** 活动预告 */
  58: '活动预告',

  /** 校友风采 */
  59: '卓越校友',
  60: '就业创业导师',
} as const

export type NoticeTag = keyof typeof noticeTagMap
export default function routerByNoticeTag(noticeTag: NoticeTag) {
  console.log('通过 noticeTag 跳转页面：', noticeTagMap[noticeTag])
  const route = router.currentRoute
  if (noticeTagMap[noticeTag] && noticeTagMap[noticeTag] !== route.path) {
    // @ts-ignore
    router.push(noticeTagMap[noticeTag])
  }
}

export function getNoticeTagName(noticeTag: NoticeTag) {
  if (noticeTagNameMap[noticeTag]) {
    return noticeTagNameMap[noticeTag]
  }
  return noticeTag
}
